import React from 'react';
import PropTypes from 'prop-types';

import IconConnector from './icon-connector.jsx';
import IconArrow from './icon-arrow.jsx';

const CompleteIcon = ({ showConnector, showArrow }) => (
    <div className="complete-icon">
        {showConnector && <IconConnector />}
        {showArrow && <IconArrow />}
        <div className="rewards-icon-outer-circle">
            <div className="rewards-icon-inner-circle">
                <div className="rewards-icon-percent">100%</div>
            </div>
        </div>
    </div>
);

CompleteIcon.propTypes = {
    showArrow: PropTypes.bool,
    showConnector: PropTypes.bool,
};

CompleteIcon.displayName = 'CompleteIcon';

export default CompleteIcon;
